import { useSyncExternalStore } from 'react';
import { ChangeSource } from './types';

/** Re-renders the consumer on every notification from the source. */
export function useChangeVersion(source: ChangeSource): void {
    useSyncExternalStore(source.subscribe, source.getVersion);
}

/**
 * Re-renders the consumer only when a primitive read from the source
 * changes. A consumer that needs one fact from a source that notifies
 * often, such as whether a row is fused from a source that also carries
 * every blend-alpha frame, reads that fact here rather than the version.
 *
 * `select` must return a primitive: `useSyncExternalStore` compares
 * snapshots by identity, and a fresh object per call would never settle.
 */
export function useSourceSnapshot<
    T extends string | number | boolean | undefined,
>(source: ChangeSource, select: () => T): T {
    return useSyncExternalStore(source.subscribe, select);
}
